export default __webpack_public_path__ + "static/7-6c56dc7571452f41deb5ec22c5fdc4b2.png";